export const DEFAULT_ERROR_SUBTITLE = `Correct the following mistakes then press Pay & Reserve again. Don't worry, you won't be charged twice.`;
